export default "__VITE_ASSET__BJDDy3Ar__"